import moment from "moment";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Table from "./Table";

export const getWeekTotal = (week) =>
	Object
		.values(week.data)
		.reduce((total, item) => ({
			duration: total.duration + item.duration,
			total: total.total + item.total,
		}), { duration: 0, total: 0 });

function Week({ week, isSameDay, canViewRates }) {
	const { t } = useTranslation();

	const data = useMemo(
		() => Object.values(week.data),
		[week.data],
	);

	return (
		<div className='timeline-block'>
			<span className='timeline-step badge-info' />

			<div className='timeline-content mw-100'>
				{!isSameDay && (
					<small className='text-muted font-weight-bold mb-2'>
						{t("weekly-summary")}:

						{" "}

						{!moment(week.startDate).isSame(week.endDate, "date") &&
							moment(week.startDate).format("DD to ")}
						{moment(week.endDate).format("DD MMM, YYYY")}
					</small>
				)}

				<Table data={data} canViewRates={canViewRates} />
			</div>
		</div>
	);
}

export default Week;
